import React from 'react';
import styled from 'styled-components';

import { generateImageFromCDN } from '../helpers';
import ExpandableCopy from './ExpandableCopy';

const Wrapper = styled.div`
  text-align: center;
`;

const Image = styled.img`
  background: center no-repeat #e8e8e8;
  /* background-size: cover;
  background-image: url(${p => p.src}); */
  border-radius: 90px;
  display: inline-block;
  height: 90px;
  margin-bottom: 1em;
  width: 90px;
`;

const Name = styled.h4`
  margin: 0 0 0.5rem;
`;

const Job = styled.h5`
  margin: 0 0 1rem;
`;

export default function Contact({
  contact,
  contact_job,
  contact_introduction,
  contact_image,
}) {
  return (
    <Wrapper>
      {contact_image && (
        <Image
          src={generateImageFromCDN(contact_image.original, {
            width: 100,
            height: 100,
            fit: 'facearea',
          })}
        />
      )}
      <Name>{contact}</Name>
      <Job>{contact_job}</Job>
      <ExpandableCopy>{contact_introduction}</ExpandableCopy>
    </Wrapper>
  );
}
